import type { CommonData } from '@/components/blockEditor/blockEditor.types';
import { CURRENT_SCHEMA_VERSION } from '@/components/blockEditor/blockEditor.types';

export function getDefaultSlatOverviewPageTwoData(): CommonData {
  return {
    version: CURRENT_SCHEMA_VERSION,
    blocks: [
      {
        id: 'slat-overview-page-two-list',
        type: 'ListItemsSection',
        props: {},
        children: {
          default: [
            {
              id: 'slat-overview-page-two-heading',
              type: 'EducationalSlideHeading',
              props: {
                title: 'Is a SLAT right for me?',
                variant: 'h3',
              },
            },
            {
              id: 'slat-overview-page-two-estate',
              type: 'PresentationListItem',
              props: {
                title: 'Estate size',
                description:
                  'If your estate exceeds or is close to the federal estate tax exemption, a SLAT can provide significant tax benefits.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'slat-overview-page-two-financial',
              type: 'PresentationListItem',
              props: {
                title: 'Financial needs',
                description:
                  "Assess your financial needs and ensure that placing assets in an irrevocable trust won't hinder your financial flexibility.",
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'slat-overview-page-two-marital',
              type: 'PresentationListItem',
              props: {
                title: 'Marital stability',
                description:
                  'Given the dependency on the marital relationship, it is crucial to consider the stability of your marriage before setting up a SLAT.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'slat-overview-page-two-guidance',
              type: 'PresentationListItem',
              props: {
                title: 'Professional guidance',
                description:
                  'Consulting with estate planning professionals, including attorneys and financial advisors, is essential to evaluate whether a SLAT aligns with your overall financial strategy.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
          ],
        },
      },
    ],
  };
}
